import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/comics';

const latestImages: Record<string, string> = {
  'comic-1': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20handsome%20male%20protagonist%20with%20glowing%20spiritual%20energy%20surrounding%20him%20modern%20city%20background%20at%20night%20dramatic%20pose%20golden%20and%20jade%20green%20color%20scheme%20clean%20simple%20background&width=200&height=280&seq=comic-cover-01&orientation=portrait',
  'comic-4': 'https://readdy.ai/api/search-image?query=Korean%20action%20webtoon%20cover%20art%20martial%20artist%20with%20long%20sword%20dramatic%20battle%20stance%20energy%20waves%20surrounding%20fiery%20orange%20and%20gold%20color%20scheme%20clean%20simple%20background&width=200&height=280&seq=comic-cover-04&orientation=portrait',
  'comic-3': 'https://readdy.ai/api/search-image?query=Korean%20thriller%20webtoon%20cover%20art%20detective%20figure%20in%20dark%20trench%20coat%20standing%20in%20rainy%20alley%20neon%20reflections%20mysterious%20silhouette%20deep%20teal%20and%20crimson%20color%20scheme%20clean%20simple%20background&width=200&height=280&seq=comic-cover-03&orientation=portrait',
  'comic-6': 'https://readdy.ai/api/search-image?query=Korean%20comedy%20webtoon%20cover%20art%20group%20of%20high%20school%20students%20laughing%20together%20in%20classroom%20bright%20sunny%20yellow%20color%20scheme%20clean%20simple%20background&width=200&height=280&seq=comic-cover-06&orientation=portrait',
  'comic-9': 'https://readdy.ai/api/search-image?query=Korean%20healing%20webtoon%20cover%20art%20cozy%20cafe%20barista%20smiling%20behind%20counter%20steaming%20coffee%20warm%20sunlight%20through%20window%20cream%20beige%20color%20scheme%20clean%20simple%20background&width=200&height=280&seq=comic-cover-09&orientation=portrait',
  'comic-5': 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20webtoon%20cover%20art%20magic%20academy%20student%20casting%20spell%20with%20magic%20circle%20floating%20books%20purple%20and%20gold%20color%20scheme%20clean%20simple%20background&width=200&height=280&seq=comic-cover-05&orientation=portrait',
};

export default function LatestSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
              最新更新
            </h2>
            <p className="mt-2 text-sm text-foreground-500">实时更新，追更不等待</p>
          </div>
          <Link
            to="/category/romance"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
          >
            更多更新 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {latestUpdates.slice(0, 6).map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group flex gap-4 p-4 rounded-lg bg-background-50 hover:bg-background-200/50 transition-colors duration-300 cursor-pointer"
            >
              <div className="w-20 h-28 shrink-0 rounded-md overflow-hidden">
                <img
                  src={latestImages[comic.id]}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex-1 min-w-0 flex flex-col justify-between">
                <div>
                  <h3 className="font-heading text-sm font-semibold text-foreground-900 line-clamp-2 group-hover:text-primary-500 transition-colors">
                    {comic.title}
                  </h3>
                  <p className="text-xs text-foreground-400 mt-1">{comic.author}</p>
                </div>
                <div>
                  <div className="flex flex-wrap gap-1.5 mb-1.5">
                    {comic.tags.slice(0, 2).map((tag) => (
                      <span
                        key={tag}
                        className="inline-block px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs whitespace-nowrap"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                  <div className="flex items-center gap-3 text-xs text-foreground-400">
                    <span className="flex items-center gap-0.5">
                      <i className="ri-star-fill text-accent-400 text-xs"></i> {comic.rating}
                    </span>
                    <span>{comic.status}</span>
                    <span>{comic.updatedAt}</span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}